export default __webpack_public_path__ + "static/media/loading-load.7893fd49.gif";